/// <amd-module name="SuiteCommerce.Blog.Common.Searcher.Helper"/>
define("SuiteCommerce.Blog.Common.Searcher.Helper", ["require", "exports", "SuiteCommerce.Blog.Common.Configuration", "SuiteCommerce.Blog.Common"], function (require, exports, Configuration_1, Common_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BlogPostSearcherError;
    (function (BlogPostSearcherError) {
        BlogPostSearcherError["taxonomyNotFound"] = "TAXONOMY_NOT_FOUND";
        BlogPostSearcherError["invalidPageRange"] = "INVALID_PAGE_RANGE";
        BlogPostSearcherError["badRequest"] = "BAD_REQUEST";
    })(BlogPostSearcherError = exports.BlogPostSearcherError || (exports.BlogPostSearcherError = {}));
    var BlogPostSearcherHelper = /** @class */ (function () {
        function BlogPostSearcherHelper() {
        }
        BlogPostSearcherHelper.buildRequestBody = function (options) {
            var requestParams = {
                paginationSettings: options.settings,
                siteId: Configuration_1.Configuration.siteId,
            };
            // Adjusting the page number (in backend the pages starts from zero)
            requestParams.paginationSettings.pageNumber -= 1;
            requestParams.filters = {};
            if (options.taxonomies.length > 0) {
                requestParams.filters.taxonomies = {};
                options.taxonomies.forEach(function (taxonomy) {
                    requestParams.filters.taxonomies[taxonomy.name] = { pinned: [taxonomy.value] };
                });
            }
            if (options.searchPhrase) {
                requestParams.filters.phrase = Common_1.sanitizeString(options.searchPhrase);
            }
            return {
                data: { blogPostSearchParameters: JSON.stringify(requestParams) },
            };
        };
        return BlogPostSearcherHelper;
    }());
    exports.BlogPostSearcherHelper = BlogPostSearcherHelper;
});
